/*eslint-disable*/
import {
  CHECK_ASSET_IMPORT,
  CHECK_CLIENT_IMPORT,
  CHECK_DISTRIBUTOR_IMPORT,
  CHECK_RELATION_IMPORT,
  CHECK_SERVICE_PROVIDER_IMPORT,
  CREATE_USER,
  EDIT_ME,
  GET_ALL_EMAIL_TEMPLATES,
  GET_ALL_PROPERTIES,
  GET_AUTH_VALUES,
  GET_AVAILABLE_LANGUAGE,
  GET_BY_INTERNAL,
  GET_CLIENT_LOGO,
  GET_CLIENTS_FILTERED,
  GET_EMAIL_TEMPLATE_BY_TYPE,
  GET_ME,
  GET_ME_AUTH,
  GET_ME_AUTH_ERROR,
  GET_ME_AUTH_PENDING,
  GET_USER,
  GET_USER_ROLE,
  GET_USERS,
  PAGINATE_USERS,
  UPDATE_USER,
  UPDATE_USER_ME,
} from "../actionTypes";

const initialState: LocalUserState = {
  me: {
    id: "",
    role: "",
    name: "",
    firstName: "",
    email: "",
    internal: false,
    language: "",
    teams: [],
    person: [],
    contact: [],
    token: "",
  },
  role: {},
  loadingGetMe: false
};
const initialStateUsers: UsersState = {
  user: {
    id: "",
    role: "",
    name: "",
    firstName: "",
    email: "",
    internal: false,
    language: "",
    teams: [],
    person: {},
    contact: {},
    token: "",
  },
  List: {
    content: [],
    pageable: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
      paged: false,
      unpaged: false,
    },
    totalPages: 0,
    totalElements: 0,
    last: false,
    number: 0,
    size: 0,
    numberOfElements: 0,
    first: false,
    empty: false,
  },
  availableLanguages: [],
};

export const LocalUserReducer = (
  state: LocalUserState = initialState,
  action: LocalUserAction
) => {
  switch (action.type) {
    case GET_ME:
      return {
        ...state,
        me: action.payload,
      };
    case EDIT_ME:
      return {
        ...state,
        me: action.payload,
      };
    case GET_ME_AUTH_PENDING:
      return {
        ...state,
        loadingGetMe:true
      }
    case GET_ME_AUTH:
      return {
        ...state,
        role: action.payload,
        loadingGetMe:false,
      };
    case GET_ME_AUTH_ERROR:
      return {
        ...state,
        loadingGetMe: false,
      }
    case UPDATE_USER_ME:
      return {
        ...state,
        me: action.payload,
      };
    default:
      return state;
  }
};

export const UsersReducer = (
  state: UsersState = initialStateUsers,
  action: UsersAction
) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        List: action.payload,
      };
    case PAGINATE_USERS:
      return {
        ...state,
        List: action.payload,
      };
    case GET_CLIENTS_FILTERED:
      return {
        ...state,
        List: action.payload,
      };
    case GET_USER:
      return {
        ...state,
        user: action.payload,
      };
    case CREATE_USER:
      return {
        ...state,
      };
    case UPDATE_USER:
      return {
        ...state,
        user: action.payload,
      };
    case GET_USER_ROLE:
      return {
        ...state,
        role: action.payload,
      };
    case GET_AUTH_VALUES:
      return {
        ...state,
        authValues: action.payload,
      };
    case GET_CLIENT_LOGO:
      return {
        ...state,
        logoClient: action.payload,
      };
    case GET_ALL_PROPERTIES:
      return {
        ...state,
        get_properties: action.payload,
      };
    case GET_ALL_EMAIL_TEMPLATES:
      return {
        ...state,
        email_templates: action.payload,
      };
    case GET_EMAIL_TEMPLATE_BY_TYPE:
      return {
        ...state,
        email_template_by_type: action.payload,
      };
    case GET_BY_INTERNAL:
      return {
        ...state,
        countUser: action.payload,
      };
    case CHECK_CLIENT_IMPORT:
      return {
        ...state,
        check_clients_import: action.payload,
      };
    case CHECK_RELATION_IMPORT:
      return {
        ...state,
        check_relations_import: action.payload,
      };
    case CHECK_DISTRIBUTOR_IMPORT:
      return {
        ...state,
        check_distributors_import: action.payload,
      };
    case CHECK_SERVICE_PROVIDER_IMPORT:
      return {
        ...state,
        check_service_providers_import: action.payload,
      }
    case CHECK_ASSET_IMPORT:
      return {
        ...state,
        check_assets_import: action.payload,
      };
    case GET_AVAILABLE_LANGUAGE:
      return {
        ...state,
        availableLanguages: action.payload,
      };
    default:
      return state;
  }
};
